import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgPipesModule, OrderByPipe, ShortenPipe } from 'ngx-pipes';
import { CarouselModule } from 'ngx-owl-carousel-o';


// ALL THE MDB PLUGIN
import { MdbCarouselModule } from 'mdb-angular-ui-kit/carousel';
import { MdbCollapseModule } from 'mdb-angular-ui-kit/collapse';
import { MdbDropdownModule } from 'mdb-angular-ui-kit/dropdown';
import { MdbTooltipModule } from 'mdb-angular-ui-kit/tooltip';
import { MdbInfiniteScrollModule } from 'mdb-angular-ui-kit/infinite-scroll';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbDatepickerModule } from 'mdb-angular-ui-kit/datepicker';
import { MdbCheckboxModule } from 'mdb-angular-ui-kit/checkbox';
import { MdbFileUploadModule } from 'mdb-angular-file-upload';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { MdbCalendarModule } from 'mdb-angular-calendar';
import { MdbAutocompleteModule } from 'mdb-angular-ui-kit/autocomplete';
import { MdbPopoverModule } from 'mdb-angular-ui-kit/popover';
import { MdbTimepickerModule } from 'mdb-angular-ui-kit/timepicker';
import { MdbChartModule } from 'mdb-angular-ui-kit/charts';
import { MdbModalModule } from 'mdb-angular-ui-kit/modal';
import { MdbNotificationModule } from 'mdb-angular-ui-kit/notification';
import { MdbScrollbarModule } from 'mdb-angular-ui-kit/scrollbar';
import { MdbSidenavModule } from 'mdb-angular-ui-kit/sidenav';
import { MdbTabsModule } from 'mdb-angular-ui-kit/tabs';
import { MdbTableModule } from 'mdb-angular-ui-kit/table';
import { MdbRippleModule } from 'mdb-angular-ui-kit/ripple';
import { MdbTreeviewModule } from 'mdb-angular-treeview';
import { MdbDragAndDropModule } from 'mdb-angular-drag-and-drop';


import { SafePipe } from 'safe-pipe';
import { MaskEmailPipe } from './pipes/mask-email.pipe';

import { ModalComponent } from './modal/modal.component';
import { AboutComponent } from './about/about.component';
import { LockScreenComponent } from './lockScreen/lock-screen.component';
import { SettingsComponent } from './settings/settings.component';
import { CalendarComponent } from './calendar/calendar.component';
import { CalendarService } from './calendar/calendar.service';
import { FileManagerComponent } from './fileManager/fileManager.component';
import { FileManagerService } from './fileManager/fileManager.service';
import { ShareModules } from './shareModules';
import { ChatComponent } from './chat/chat.component';
import { CalculatorComponent } from './calculator/calculator.component';


@NgModule({
    imports: [
        // dep modules
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgPipesModule,
        CarouselModule,
        SafePipe,
        MaskEmailPipe,
        ShareModules,

        // MDB modules
        MdbSidenavModule,
        MdbModalModule,
        MdbNotificationModule,
        MdbDropdownModule,
        MdbCollapseModule,
        MdbTooltipModule,
        MdbInfiniteScrollModule,
        MdbFormsModule,
        MdbFileUploadModule,
        MdbDatepickerModule,
        MdbCheckboxModule,
        MdbSelectModule,
        MdbCalendarModule,
        MdbAutocompleteModule,
        MdbPopoverModule,
        MdbTimepickerModule,
        MdbChartModule,
        MdbTabsModule,
        MdbTableModule,
        MdbCarouselModule,
        MdbScrollbarModule,
        MdbRippleModule,
        MdbTreeviewModule,
        MdbDragAndDropModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
    declarations: [
        ModalComponent,
        AboutComponent,
        LockScreenComponent,
        SettingsComponent,
        CalendarComponent,
        FileManagerComponent,
        ChatComponent,
        CalculatorComponent
    ],
    providers: [OrderByPipe, ShortenPipe, CalendarService, FileManagerService],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgPipesModule,
        CarouselModule,
        SafePipe,
        MaskEmailPipe,
        ShareModules,

        ModalComponent,
        AboutComponent,
        LockScreenComponent,
        SettingsComponent,
        CalendarComponent,
        FileManagerComponent,
        ChatComponent,
      
        MdbSidenavModule,
        MdbModalModule,
        MdbNotificationModule,
        MdbDropdownModule,
        MdbCollapseModule,
        MdbTooltipModule,
        MdbInfiniteScrollModule,
        MdbFormsModule,
        MdbFileUploadModule,
        MdbDatepickerModule,
        MdbCheckboxModule,
        MdbSelectModule,
        MdbCalendarModule,
        MdbAutocompleteModule,
        MdbPopoverModule,
        MdbTimepickerModule,
        MdbChartModule,
        MdbTabsModule,
        MdbTableModule,
        MdbCarouselModule,
        MdbScrollbarModule,
        MdbRippleModule,
        MdbTreeviewModule,
        MdbDragAndDropModule,
    ]
})
export class AppPipesModule { }